import { fp32 } from '@luma.gl/core';
import geometry from '../misc/geometry';
import projectShader from './project.glsl';
import { getUniformsFromViewport } from './viewport-uniforms';
const INITIAL_MODULE_OPTIONS = {};

function getUniforms(opts = INITIAL_MODULE_OPTIONS) {
  if ('viewport' in opts) {
    return getUniformsFromViewport(opts);
  }

  return {};
}

export default {
  name: 'project',
  dependencies: [fp32, geometry],
  vs: projectShader,
  getUniforms
};
//# sourceMappingURL=project.js.map